import { render, staticRenderFns } from "./56xinghengvideo.vue?vue&type=template&id=4ef658e0&"
import script from "./56xinghengvideo.vue?vue&type=script&lang=js&"
export * from "./56xinghengvideo.vue?vue&type=script&lang=js&"
import style0 from "./56xinghengvideo.vue?vue&type=style&index=0&id=4ef658e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports